export * as Popper from '@popperjs/core'

export { default as Alert } from './bootstrap/alert'
export { default as Button } from './bootstrap/button'
export { default as Carousel } from './bootstrap/carousel'
export { default as Collapse } from './bootstrap/collapse'
export { default as Dropdown } from './bootstrap/dropdown'
export { default as Modal } from './bootstrap/modal'
export { default as Offcanvas } from './bootstrap/offcanvas'
export { default as Popover } from './bootstrap/popover'
export { default as ScrollSpy } from './bootstrap/scrollspy'
export { default as Tab } from './bootstrap/tab'
export { default as Toast } from './bootstrap/toast'
export { default as Tooltip } from './bootstrap/tooltip'

import Alert from './bootstrap/alert'
import Button from './bootstrap/button'
import Carousel from './bootstrap/carousel'
import Collapse from './bootstrap/collapse'
import Dropdown from './bootstrap/dropdown'
import Modal from './bootstrap/modal'
import Offcanvas from './bootstrap/offcanvas'
import Popover from './bootstrap/popover'
import ScrollSpy from './bootstrap/scrollspy'
import Tab from './bootstrap/tab'
import Toast from './bootstrap/toast'
import Tooltip from './bootstrap/tooltip'

export const bootstrap = {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip
}
